import {useContext} from 'react';

import {FullAccessHeader} from './Components/FullAccessHeader';
import {LimitedAccessHeader} from './Components/LimitedAccessHeader';
import {UserContext} from '../../../../contexts/UserContext/UserContext';

export const CompanyAppHeader = () => {
  const {currentUser, isContractSigned} = useContext(UserContext);
  const shouldDisplayLimitedAccessHeader = !currentUser?.accountConfirmed || !isContractSigned;

  if (shouldDisplayLimitedAccessHeader) {
    return <LimitedAccessHeader />;
  }

  return <FullAccessHeader />;
};
